import type { ReactNode } from "react";
import { cn } from "@/shared/lib/cn";

export interface DividerProps {
  /** Texto centrado entre las dos líneas — normalmente "O". */
  label?: ReactNode;
  className?: string;
}

/**
 * Divisor con degradado a los lados: la línea se desvanece hacia los
 * bordes en vez de cortarse en seco. Es el mismo gesto del sistema actual.
 *
 * Sin `label` es un `<hr>` semántico; con `label` es una fila decorativa
 * cuyo texto sí se lee.
 */
export function Divider({ label, className }: DividerProps) {
  if (!label) {
    return (
      <hr
        className={cn(
          "h-px border-0 bg-gradient-to-r from-transparent via-ds-lilac/50 to-transparent",
          className,
        )}
      />
    );
  }

  return (
    <div className={cn("flex items-center gap-3", className)}>
      <span
        aria-hidden="true"
        className="h-px flex-1 bg-gradient-to-r from-transparent via-ds-lilac/50 to-transparent"
      />
      <span className="text-[11px] uppercase tracking-ds-label text-ds-ink-3">{label}</span>
      <span
        aria-hidden="true"
        className="h-px flex-1 bg-gradient-to-r from-transparent via-ds-lilac/50 to-transparent"
      />
    </div>
  );
}
